import { createSlice } from '@reduxjs/toolkit';
import { getTransactions, getOrgTransactions, getSuspenseTransactions, getBillingTransactions } from './expenseMiddleware';
import { type ExpenseResponse, type Expense, type TransactionResponse, type BillingLedgerEntry, type BillingBalance } from './expenseTypes';

interface InitialState {
  expense: Expense;
  transactions: ExpenseResponse[];
  orgTransactions: TransactionResponse[];
  suspenseTransactions: ExpenseResponse[];
  billingTransactions: BillingLedgerEntry[];
  billingBalances: BillingBalance[];
}

const initialState: InitialState = {
  expense: {
    description: '',
    amount: '',
    date: '',
    type: ''
  },
  transactions: [],
  orgTransactions: [],
  suspenseTransactions: [],
  billingTransactions: [],
  billingBalances: []
};

const expenseReducer = createSlice({
  name: 'expenseReducer',
  reducers: {},
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getTransactions.fulfilled, (state, action) => {
      state.transactions = action.payload;
    });
    builder.addCase(getOrgTransactions.fulfilled, (state, action) => {
      state.orgTransactions = action.payload;
    });
    builder.addCase(getSuspenseTransactions.fulfilled, (state, action) => {
      state.suspenseTransactions = action.payload;
    });
    builder.addCase(getBillingTransactions.fulfilled, (state, action) => {
      state.billingTransactions = action.payload.entries;
      state.billingBalances = action.payload.balances;
    });
  },
});

export default expenseReducer.reducer;
